import styled from 'styled-components'

const CodeDialogBody = styled.div`
  .ace_info {
    display: none;
  }
`

export default CodeDialogBody
